module.exports = __webpack_public_path__ + "img/call-background-flip.de639829.png";